<template>
    <a-date-picker
            :value="dateValue"
            allowClear
            showTime
            :placeholder="placeholder"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            @change="onChange"/>
</template>

<script>
    export default {
        props:{
            dateValue:{
                type:String,
                default:''
            },
            placeholder:{
                type:String,
                default:''
            }
        },
        methods:{
            onChange(date, dateString){
                this.$emit('update:dateValue',dateString)
            }
        }
    }
</script>

<style scoped>

</style>
